import React from 'react';
import If from 'components/if-statement';

import {
  Container,
  Button,
  RoleIndicator,
  SharedIndicator,
  ShareSurfaceModal,
} from './style';
import { useTranslation } from 'i18n';
import useSurfacePermissions from 'components/canvas/hooks/use-surface-permissions';
import useSurfaceRolesMap from 'routes/surface/hooks/use-surface-roles-map';
import { ModalContext } from 'hoc/with-modal';

function ShareSurfaceButton({ surface }) {
  const { t } = useTranslation();

  const surfaceRoleMap = useSurfaceRolesMap();

  const modal = React.useRef<ModalContext>(null);

  const { canShareSurfaceNode } = useSurfacePermissions(surface);

  const isShared = surface?.isShared;

  const notSharedSurfacesRootOrHome =
    !surface.sharedSurfacesRoot && !surface.rootSurface;

  const label = isShared ? t('Sharing') : t('Share cell');

  const role = surfaceRoleMap[surface.loggedUserRole];

  const showRole = isShared && role;

  function onClick() {
    modal.current?.setData(surface);
    modal.current?.show();
  }

  return (
    <Container>
      <ShareSurfaceModal ref={modal} />

      <If condition={notSharedSurfacesRootOrHome}>
        <>
          {showRole && <RoleIndicator>{role}</RoleIndicator>}
          {canShareSurfaceNode() && (
            <>
              <Button tertiary label={label} onClick={onClick} />
              {isShared && <SharedIndicator />}
            </>
          )}
        </>
      </If>
    </Container>
  );
}

export default ShareSurfaceButton;
